import React from "react";

export default function LightsAndMountIcon(props) {
  return(
      <img src="/Icons/lightsAndMount.svg" alt="lights and mount" {...props}/>
  )
}
